import {gsap} from "gsap";
import {SplitText} from "../../../plugins/gsap/SplitText";

gsap.registerPlugin(SplitText);
export default class AnimationMobile {
    constructor() {
        this.init();
        this.heroAnimation();
        this.initAppearAnimation();
    }

    init() {
        this.html = {}

        this.heroEl = document.getElementById('hero')
        this.logoEl = this.heroEl.querySelector('.hero--logo')
        this.titleEl = this.heroEl.querySelector('.hero--title')
        this.headingEl = this.heroEl.querySelector('.hero--heading')

        this.html.hero = {
            el: this.heroEl,
            logo: this.logoEl,
            title: this.titleEl,
            heading: this.headingEl
        }

        this.heroThesisEl = document.querySelector('.scroll-block.thesis')
        this.heroThesisBackgroundEl = document.querySelector('.scroll-block.thesis .scroll-block-bg')
        this.thesisTextHolderEl = document.querySelector('.scroll-content .text-holder')
        this.thesisTextEl = this.heroThesisEl.querySelectorAll('.text-holder p')

        this.html.slidePanel = {
            el: this.heroThesisEl,
            background: this.heroThesisBackgroundEl,
            thesisTextHolderEl: this.thesisTextHolderEl,
            thesisTextEl: this.thesisTextEl
        }

        this.landingEl = document.getElementById('landing')
        this.landingContainerEl = this.landingEl.querySelector(':scope > .container')
        this.landingHeader = this.landingEl.querySelector('.header')
        this.landingHeadingEls = this.landingEl.querySelectorAll('.header > *')
        this.cards = this.landingEl.querySelectorAll('.card-item')
        this.landingBackgroundEl = this.landingEl.querySelector('.gw-grid')
        this.landingVerticalLines = this.landingEl.querySelector('.gw-vertical-lines')
        this.animatedGridEl = document.querySelector('.grid-animation-container')

        this.html.landing = {
            el: this.landingEl,
            container: this.landingContainerEl,
            header: this.landingHeader,
            heading: this.landingHeadingEls,
            cards: this.cards,
            grid: this.landingBackgroundEl,
            verticalLines: this.landingVerticalLines,
            animatedGridEl: this.animatedGridEl
        }

        this.latestEl = document.querySelector('.gm2-latest')
        this.latestHeader = this.latestEl.querySelector('.header')
        this.latestHeadingEls = this.latestEl.querySelectorAll('.header > *')
        this.latestSlider = this.latestEl.querySelector('.swiper-latest-growth')

        this.html.latest = {
            el: this.latestEl,
            header: this.latestHeader,
            heading: this.latestHeadingEls,
            slider: this.latestSlider
        }

        this.evolutionEl = document.querySelector('.gm2-player')
        this.evolutionHeader = this.evolutionEl.querySelector('.heading')
        this.evolutionHeadingEls = this.evolutionEl.querySelectorAll('.heading > *')
        this.evolutionBackgroundEl = this.evolutionEl.querySelector('.gm2-player-background')
        this.evolutionVideosContainer = this.evolutionEl.querySelector('.videos-container')

        this.html.evolution = {
            el: this.evolutionEl,
            header: this.evolutionHeader,
            heading: this.evolutionHeadingEls,
            background: this.evolutionBackgroundEl,
            videos: this.evolutionVideosContainer
        }
    }

    heroAnimation() {
        if(this.html.slidePanel.thesisTextEl) {
            this.thesisText = new SplitText(this.html.slidePanel.thesisTextEl, { type: "lines,words", wordsClass: 'js-word-thesis' });
            this.html.slidePanel.thesisTextHolderEl.style.opacity = 1;
        }

        const tl = gsap.timeline();

        tl
            .to(this.html.hero.logo, {
                duration: 1,
                y: 0,
                force3D: true,
                opacity: 1,
                ease: 'power2.out'
            })
            .to(this.html.hero.title, {
                duration: 1,
                opacity: 1,
                y: 0,
                force3D: true,
                ease: 'power2.out',
                onComplete: () => {
                    const event = new CustomEvent('introTitleComplete');
                    window.dispatchEvent(event);
                }
            }, '-=0.5')
            .to(this.html.hero.heading, {
                duration: 1,
                opacity: 1,
                y: 0,
                force3D: true,
                ease: 'power2.out'
            }, '-=0.5')

        const progressList = {
            thesisFrame: 0
        }

        tl
            .to(progressList, {
                thesisFrame: 100,
                duration: 1,
                ease: "power2.out",
            }, 0.7)
            .to(this.thesisText.words, {
                opacity: 1,
                duration: .4,
                force3D: true,
                ease: "power2.out",
                stagger: {
                    amount: .6
                },
            }, 0.7)
    }

    initAppearAnimation() {
        const landingAppear = [
                ...this.html.landing.el.querySelectorAll('.header > *'),
                ...this.html.landing.el.querySelectorAll('.card-item'),
        ]

        const latestAppear = [
            ...this.html.latest.el.querySelectorAll('.header > *'),
            this.html.latest.el.querySelector('.swiper-latest-growth')
        ]

        const evolutionAppear = [
            ...this.html.evolution.el.querySelectorAll('.heading > *'),
            this.html.evolution.el.querySelector('.videos-container')
        ]

        // set delay to appear
        landingAppear.forEach((el, index) => {
            el.style.setProperty('--delay', `${index * 0.15}s`)
        })

        latestAppear.forEach((el, index) => {
            el.style.setProperty('--delay', `${index * 0.15}s`)
        })

        evolutionAppear.forEach((el, index) => {
            el.style.setProperty('--delay', `${index * 0.15}s`)
        })

        const elementsToAppear = [
            this.html.landing.el,
            this.html.latest.el,
            this.html.evolution.el
        ]

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            threshold: 0.2
        });

        elementsToAppear.forEach(el => {
            this.observer.observe(el);
        })
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-appeared');
                this.observer.unobserve(entry.target);
            }
        });
    }
}
